module.exports = __webpack_public_path__ + "img/icon-passport-small-avatar.5a3f460f.svg";